var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStatusIcon = function SvgStatusIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 0C7.7 0 4.3 3.2 3.9 7.2H1C0.4 7.2 0 7.6 0 8.2C0 8.8 0.4 9.2 1 9.2H8.6C8.9 9.2 9.2 9.1 9.4 8.8L10 8.1L11.1 10.9C11.2 11.3 11.6 11.5 11.9 11.5H12C12.3 11.5 12.7 11.3 12.8 11L14.2 8.9H15.3C15.9 8.9 16.3 8.5 16.3 7.9C16.3 7.3 15.9 6.9 15.3 6.9H13.7C13.4 6.9 13 7.1 12.9 7.4L12.3 8.4L11.3 5.8C11.2 5.5 10.9 5.2 10.5 5.2C10.1 5 9.7 5.2 9.5 5.5L8.1 7.2H6C6.4 3.9 9.6 1.4 13.1 2.1C15.3 2.6 17.1 4.4 17.6 6.6C18.4 10.4 15.5 13.8 11.8 13.8C10.3 13.8 8.9 13.2 7.8 12.3C7.4 12 6.9 12 6.5 12.3C6 12.7 6 13.4 6.4 13.8C8.2 15.4 10.7 16.3 13.4 15.7C16.4 15.1 18.9 12.6 19.5 9.6C20.5 4.4 16.7 0 11.8 0Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatusIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status-icon.870da7d3.svg";
export { ForwardRef as ReactComponent };